import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { VasAppFacade } from '../../../vas/services/vas-app-facade.service';
import * as actions from './text-control-mobile-modal.actions';

@Injectable()
export class TextControlMobileModalEffects {

    @Effect()
    init$ = this.actions$
        .ofType(actions.INIT)
        .switchMap((action: actions.InitAction) => {

            return this.appFacade.objects.lookup.store
                .getBy(
                    lookup => lookup.lookupType === action.payload.lookupTypeId
                )
                .take(1)
                .map(lookups => new actions.InitSuccessAction({
                    lookups
                }));
        });

    constructor(
        protected actions$: Actions,
        protected appFacade: VasAppFacade
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/modals-popovers/text-control-mobile-modal/text-control-mobile-modal.effects.ts